import React from 'react';
import Hero from '../components/Hero';
import Technology from '../components/Technology';
import Products from '../components/Products';
import DashboardPreview from '../components/DashboardPreview';
import DocsYouTube from '../components/DocsYouTube';

import EducationBanner from '../components/EducationBanner';

const Home = () => {
    return (
        <>
            <Hero />
            <EducationBanner />
            <Technology />
            <Products />
            <DashboardPreview />
            <DocsYouTube />
        </>
    );
};

export default Home;
